import { getLeagueFlowTexts } from "../leagueFlowTexts";

type Props = { current: number };
export default function LeagueFlowSteps({ current }: Props) {
  const t = getLeagueFlowTexts();
  return <ol className="league-flow-steps" aria-label={t.stepsLabel}>
    {[t.general, t.rules, t.review].map((label, index) => <li key={label} aria-current={index === current ? "step" : undefined} className={index < current ? "is-complete" : ""}>
      <span aria-hidden="true">{index < current ? "✓" : index + 1}</span><strong>{label}</strong>
    </li>)}
  </ol>;
}
